import React from 'react';
import PropTypes from 'prop-types';
import Header from 'components/Admin/shared/Table/Header.jsx';

const titles = {
  name: 'NAME',
  email: 'EMAIL'
};

const miniLabel = {
  first_name: 'First name',
  last_name: 'Last name'
};

const additionalProps = {
  created_at: {
    revert: true,
  },
  last_login: {
    revert: true
  },
  logins: {
    thProps: {
      //colSpan: '2'
    },
    disabled: true
  },
  name: {
    values: ['first_name', 'last_name'],
    miniLabels: miniLabel
  }
};

function HeadersNewWebinar({
                   onChange,
                   value: selectedValue,
                 }) {
  return (
    <tr>
      <th></th>
      {Object.keys(titles).map(value => (
        <Header
          onChange={onChange}
          key={value}
          values={[value]}
          title={titles[value]}
          selected={selectedValue}
          {...(additionalProps[value]) || {}}
        />
      ))}
    </tr>
  );
}

Headers.defaultProps = {};

Headers.propTypes = {};

export default HeadersNewWebinar;



// WEBPACK FOOTER //
// ./src/components/AddUsersWebinar/HeaderNewWebinar.jsx